// removed by extract-text-webpack-plugin
module.exports = {"Size":"Resize__Size__FiVG_","SizeDetails":"Resize__SizeDetails__3OzOg","Current":"Resize__Current__19NTz"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/GameMenu/ListElements/Resize/Resize.css
// module id = 98
// module chunks = 0